<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width400 full-height" header="Optionen">
        <sm-form  [form]="form">
        </sm-form>
        <p-button styleClass="mt-3" icon="fas fa-barcode" label="Barcodes ermitteln" (onClick)="findBarcodes()"></p-button>
    </p-panel>
    <sm-table2 *ngIf="table != null" class="flex-item-fill height100p" [data]="table" [headerHeight]=150></sm-table2>
</div>
<app-progressor-overlay [progressor]="progressor.value" [showCalculated]=false></app-progressor-overlay>
